import React, { useState } from 'react';
import { achievements, achievementTypes } from '../data/achievements';
import './Achievements.css';

const Achievements = () => {
  const [selectedType, setSelectedType] = useState('all');
  const [imageErrors, setImageErrors] = useState(new Set());

  const filteredAchievements = achievements.filter(achievement => 
    selectedType === 'all' || achievement.type === selectedType
  );

  const handleImageError = (achievementId) => {
    setImageErrors(prev => new Set(prev).add(achievementId));
  };

  return (
    <div className="achievements">
      <div className="achievements-header">
        <div className="container">
          <h1>Achievements & Recognition</h1>
          <p>Celebrating success in children's fashion photography</p>
        </div>
      </div>

      <div className="achievements-controls">
        <div className="container">
          <div className="type-filters">
            {achievementTypes.map(type => (
              <button
                key={type.id}
                className={`type-btn ${selectedType === type.id ? 'active' : ''}`}
                onClick={() => setSelectedType(type.id)}
              >
                {type.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="achievements-content">
        <div className="container">
          <div className="achievements-grid">
            {filteredAchievements.map((achievement) => (
              <div key={achievement.id} className="achievement-item">
                {achievement.imageUrl && !imageErrors.has(achievement.id) ? (
                  <img 
                    src={achievement.imageUrl} 
                    alt={achievement.title}
                    className="achievement-image"
                    onError={() => handleImageError(achievement.id)}
                  />
                ) : (
                  <div className="achievement-image-placeholder">
                    <span>{achievement.type}</span>
                  </div>
                )}
                <div className="achievement-content">
                  <div className="achievement-header">
                    <h3>{achievement.title}</h3>
                    <span className="achievement-type">{achievement.type}</span>
                  </div>
                  <p className="achievement-date">
                    {new Date(achievement.date).toLocaleDateString()}
                  </p>
                  <p className="achievement-description">
                    {achievement.description}
                  </p>
                  {achievement.link && (
                    <a 
                      href={achievement.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      View Article
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="achievements-stats">
        <div className="container">
          <h2>Recognition Summary</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">
                {achievements.filter(a => a.type === 'magazine').length}
              </div>
              <div className="stat-label">Magazine Features</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">
                {achievements.filter(a => a.type === 'award').length}
              </div>
              <div className="stat-label">Awards Won</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">
                {achievements.filter(a => a.type === 'exhibition').length}
              </div>
              <div className="stat-label">Exhibitions</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">
                {new Date().getFullYear() - 2021}
              </div>
              <div className="stat-label">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Achievements;
